module.exports = __webpack_public_path__ + "static/media/camera_on.87f1865f.svg";